exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inp-error__text1[data-v-fc7dc1d4]{color:#e41b1b}.inp-error__text1[data-v-fc7dc1d4],.inp-error__text2[data-v-fc7dc1d4]{font-size:14px;display:block;margin:0 0 .5rem;line-height:100%}.inp-error__text2[data-v-fc7dc1d4]{color:#000}", ""]);

// exports
